import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
// Note: You can change "images" to whatever you'd like.
const RawImage = props => {
    return (
  <StaticQuery
    query={graphql`
      query {
        rawImages: allFile {
          edges {
            node {
              relativePath
              name
              ext
              publicURL
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.rawImages.edges.find(n => {
          const ext = n.node.ext
        return n.node.relativePath.includes(props.filename) && (ext == '.svg'  || ext == '.gif')
      });
      if (!image || !props.filename) {
          return null
      }
        const url = image.node.publicURL
      return <img {...props} src={url} />
    }}
  />
    )
    
}

export default RawImage
